import React, { memo } from "react";
import styles from "./styles.module.scss";
import SearchBar from "app/components/inputs/SearchBar";
import { CreateNewGroupModal } from "./_components/CreateNewGroupModal";
import { useTranslation } from "react-i18next";
import CoachHomeLayout from "app/components/Layouts/CoachHomeLayout";

interface LayoutWrapperProps {
  children: React.ReactNode;
  onSearchGroup: (term: string) => void;
  isOpenCreateGroupModal: boolean;
  createGroupModalHandler: () => void;
}

const LayoutWrapper = ({
  children,
  onSearchGroup,
  isOpenCreateGroupModal,
  createGroupModalHandler,
}: LayoutWrapperProps) => {
  const { t } = useTranslation();

  return (
    <CoachHomeLayout>
      <SearchBar
        className={styles.search}
        placeholder={t("Search groups...")}
        onChange={onSearchGroup}
      />
      {children}
      {isOpenCreateGroupModal && (
        <CreateNewGroupModal
          isOpen={isOpenCreateGroupModal}
          onClose={createGroupModalHandler}
        />
      )}
    </CoachHomeLayout>
  );
};

export default memo(LayoutWrapper);
